/* eslint-disable max-len */
const compose = (...fns) => (...args) => fns.reduceRight((res, fn) => [fn.call(null, ...res)], args)[0];


/* eslint-disable prefer-const */
function equality(...args) {
	let [prop1, prop2] = args;
	if (!prop2) {
		prop2 = prop1;
	}
	return function inner(item) {
		return item[prop1] === prop2;
	};
}

function find(fn, col) {
	return col.find(fn);
}

function matchBetweenArrays(collection1, collection2) {
	const [arr1, prop1] = collection1;
	const [arr2, prop2] = collection2;
	let list = [];
	if (prop2) {
		arr1.forEach((a) => {
			const val = prop1 ? a[prop1] : a;
			const match = find(equality(prop2, val), arr2);
			list = list.concat(match);
		});
	}
	if (
		arr1.every(a => typeof a === 'string' || typeof a === 'number') &&
		arr2.every(a => typeof a === 'string' || typeof a === 'number')
	) {
		arr1.forEach((a) => {
			const match = arr2.find(b => a === b);
			list = match ? list.concat(match) : list;
		});
	}
	return list;
}

function getDeeper(...args) {
	return function inner(item) {
		let newItem = null;
		if (item.length) {
			[newItem] = item;
		} else {
			newItem = { ...item };
		}
		args.forEach((el) => {
			newItem = (newItem || {})[el];
		});
		return newItem;
	};
}

function setNewProperty(property, value) {
	return function p(obj) {
		const newObj = { ...obj };
		newObj[property] = value;
		return newObj;
	};
}

function updateItemInCollection(matchProp, ele, collection) {
	return collection.reduce((list, item) => {
		if (ele[matchProp] === item[matchProp]) {
			return list.concat(ele);
		}
		return list.concat(item);
	}, []);
}

function getPropertysValue(prop) {
	return function inner(obj) {
		return (obj || {})[prop];
	};
}

function createPropertyByOtherOne(...args) {
	const [prop1, prop2] = args;
	return function inner(item) {
		let newItem = null;
		if (item.length) {
			[newItem] = item;
		} else {
			newItem = { ...item };
		}
		newItem[prop1] = getPropertysValue(prop2)(newItem);
		return newItem;
	};
}

function filter(fn, collection) {
	return collection.filter(fn);
}

function setNewPropertyByFunction(prop, fn, flag = true) {
	return function inner(item, index) {
		if (index === null || index === undefined) {
			if (item.length) {
				const [newItem, newIndex] = item;
				return [setNewProperty(prop, fn(newItem, newIndex))(newItem), newIndex];
			}
			return setNewProperty(prop, fn(item, index))(item);
		}
		if (flag) {
			return [setNewProperty(prop, fn(item, index))(item), index];
		}
		return setNewProperty(prop, fn(item, index))(item);
	};
}

function removeItemFromArray(prop, propValue) {
	return function inner(arr) {
		const newArr = arr || [];
		return newArr.reduce((list, item) => {
			const newList = [...list];
			if (propValue === item[prop]) {
				return newList;
			}
			return newList.concat(item);
		}, []);
	};
}

function removeItemFromArrayByIndex(index, arr) {
	return arr.reduce((list, item, ind) => {
		const newList = [...list];
		if (index === ind) {
			return newList;
		}
		return newList.concat(item);
	}, []);
}

export default {
	compose,
	createPropertyByOtherOne,
	equality,
	filter,
	find,
	getDeeper,
	getPropertysValue,
	matchBetweenArrays,
	removeItemFromArray,
	removeItemFromArrayByIndex,
	setNewProperty,
	setNewPropertyByFunction,
	updateItemInCollection,
};



// WEBPACK FOOTER //
// ./src/lib.js